import { render, staticRenderFns } from "./Availability.vue?vue&type=template&id=163bfc04&scoped=true"
import script from "./Availability.vue?vue&type=script&lang=js"
export * from "./Availability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163bfc04",
  null
  
)

export default component.exports